import { isNullOrEmpty } from '../../../utils/isNullOrEmpty';
import {
  validateCategoryId,
  validateName,
} from '../../utils/reportFieldsValidation';

import { EditReportFormValidationSummary } from './editReportInterfaces';

export enum EditReportFields {
  'categoryId',
  'name',
}

export const ValidateEditReportField = (
  field: EditReportFields,
  value: string,
  validationSummary: EditReportFormValidationSummary,
  setValidationSummary: React.Dispatch<
    React.SetStateAction<EditReportFormValidationSummary>
  >
) => {
  const validationErrors = validationSummary.validationErrors;

  let categoryValid = validationSummary.categoryIdValid;
  let nameValid = validationSummary.nameValid;

  switch (field) {
    case EditReportFields.categoryId:
      validationErrors.categoryId = validateCategoryId(value);
      categoryValid = isNullOrEmpty(validationErrors.categoryId);
      break;
    case EditReportFields.name:
      validationErrors.name = validateName(value);
      nameValid = isNullOrEmpty(validationErrors.name);
      break;
    default:
      break;
  }

  setValidationSummary({
    categoryIdValid: categoryValid,
    nameValid: nameValid,
    validationErrors: validationErrors,
    formValid: categoryValid && nameValid,
  });
};
